module.exports = __webpack_public_path__ + "assets/img/i_pay2.3d60bc6b.png";